import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';
import { setLayoutSettings, setDefaultSettings } from '../../redux/actions/layout';
import { logoutUser } from '../../redux/actions/user';
import { withRouter } from 'react-router-dom';
import { Sidenav, Brand } from '../../sharedComponent';
import SidenavTheme from '../Theme/SidenavTheme/SidenavTheme';
import { isMdScreen } from '../../utils/methods';
import { merge } from 'lodash';

const styles = (theme) => ({});

const IconButtonWhite = withStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		padding: '5px',
	},
}))(IconButton);

const IconSmall = withStyles(() => ({
	root: {
		fontSize: '1rem',
	},
}))(Icon);

class LayoutSidenav extends Component {
	state = {
		hidden: true,
	};
	_isMounted = false;

	componentDidMount() {
		this.unlistenRouteChange = this.props.history.listen((location, action) => {
			if (isMdScreen()) {
				this.updateSidebarMode({ mode: 'close' });
			}
		});
		this._isMounted = true;
		setTimeout(() => {
			if (this._isMounted) {
				this.setState({ hidden: false });
			}
		}, 400);
	}

	componentWillUnmount() {
		this.unlistenRouteChange();
		this._isMounted = false;
	}

	updateSidebarMode = (sidebarSettings) => {
		let { settings, setLayoutSettings, setDefaultSettings } = this.props;
		const updatedSettings = merge({}, settings, {
			SettingsLayout: {
				leftSidebar: {
					...sidebarSettings,
				},
			},
		});

		setLayoutSettings(updatedSettings);
		setDefaultSettings(updatedSettings);
	};

	handleSignOut = () => {
		this.props.logoutUser();
	};

	renderLogoSwitch = () => <Brand></Brand>;

	renderUser = () => {
		let { user } = this.props;
		return (
			<div className="sidenav__user">
				<div className="username-photo">
					<img src="/assets/images/face.png" alt="user" />
				</div>
				<div className="ml-4">
					<span className="username capitalize">{user.name}</span>
					{/* <div className="user__menu">
            <Tooltip title="Sign out">
              <IconButtonWhite
                aria-label="Delete"
                className=""
                size="small"
                onClick={this.handleSignOut}
              >
                <IconSmall>exit_to_app</IconSmall>
              </IconButtonWhite>
            </Tooltip>
          </div> */}
				</div>
			</div>
		);
	};

	render() {
		let { theme, settings } = this.props;
		const sidenavTheme = settings.themes[settings.SettingsLayout.leftSidebar.theme] || theme;
		return (
			<SidenavTheme theme={sidenavTheme} settings={settings}>
				<div className="sidenav">
					<div
						className="sidenav__hold"
						style={{
							backgroundImage: `url(${settings.SettingsLayout.leftSidebar.bgImgURL})`,
						}}
					>
						{!this.state.hidden && (
							<Fragment>
								{this.renderLogoSwitch()}
								<Sidenav>{this.renderUser()}</Sidenav>
							</Fragment>
						)}
					</div>
				</div>
			</SidenavTheme>
		);
	}
}

LayoutSidenav.propTypes = {
	setLayoutSettings: PropTypes.func.isRequired,
	setDefaultSettings: PropTypes.func.isRequired,
	logoutUser: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired,
	settings: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	setDefaultSettings: PropTypes.func.isRequired,
	setLayoutSettings: PropTypes.func.isRequired,
	logoutUser: PropTypes.func.isRequired,
	user: state.user,
	settings: state.layout.settings,
});

export default withStyles(styles, { withTheme: true })(
	withRouter(
		connect(mapStateToProps, {
			setLayoutSettings,
			setDefaultSettings,
			logoutUser,
		})(LayoutSidenav)
	)
);
